import { render, staticRenderFns } from "./InitError.vue?vue&type=template&id=1400fb14"
import script from "./InitError.vue?vue&type=script&lang=js"
export * from "./InitError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports